export default __webpack_public_path__ + "img/pk-96247be5.png";